<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    style="padding-left: 30px; padding-right: 30px;"
>

<div
    class="outer_container"
>

    <div
        class="left_pane"
    >
        <m-form-editor
            v-on:title="title = $event;"
            v-on:change="onChange"
            v-on:toggle-show-after-submit="$refs['preview'].toggleShowAfterSubmit()"
        />
    </div>

    <div
        class="right_pane"
    >
        <m-custom-form-control
            ref="preview"
            :in_test_mode="true"
            preview
        />
    </div>

</div>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            title: 'Form editor',
        }
    },

    methods: {
        onChange() {
            this.$refs['preview'].update();
        },
    },
}
</script>

<style lang="scss" scoped>
.outer_container
{
    display: flex;

    position: absolute;
    top: 0;
    bottom: 0;
    left: 15px;
    right: 15px;
}

.left_pane
{
    flex-grow: 1; 
    overflow-x: hidden; 
    overflow-y: auto;
    padding-right: 15px; 
    padding-bottom: 15px;
    min-width: 50%;
    max-width: 600px;
}

.right_pane
{
    flex-grow: 1; 
    padding-left: 30px; 
    padding-right: 30px;
    overflow-x: hidden; 
    overflow-y: auto;
}


@media only screen and (max-width: 920px)
{
    .right_pane{
        display: none;
    }

    .left_pane {
        max-width: none;
    }


}

</style>